var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8DD9F6",
    d: "M13.285 17.571a5.571 5.571 0 1 0 0-11.142a5.571 5.571 0 0 0 0 11.142"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6161F6",
    d: "M14.194 13.056a1.286 1.286 0 0 0-.012-2.199L7.09 6.605a1.286 1.286 0 0 0-1.947 1.102v8.608A1.286 1.286 0 0 0 7.1 17.41z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPly);
export default __webpack_public_path__ + "static/media/ply.6cd304d0ec51a2bd30066f40435dd37d.svg";
export { ForwardRef as ReactComponent };